export function createHighlights(hit, fieldName, tokensFieldName) {
  const tokensHighlights = hit.getIn(['_highlightResult', tokensFieldName]);
  return tokensHighlights ? tokensHighlights.filter(h => h.get('matchLevel') !== 'none').map(h => h.get('value')).push(hit.getIn(['_highlightResult', fieldName, 'value'])).join(' ') : hit.getIn(['_highlightResult', fieldName, 'value']);
}